'use client';
import React, { useState, useRef } from 'react';
import ProfileDetails from './ProfileDetails';
// import ChangePassword from './ChangePassword';
import ChangePassword from './ChangePassword1';
import Header from './Header';
import { useNavigate } from 'react-router-dom'; // for logout redirect


const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
   const isSubscribed = localStorage.getItem('isSubscribed') === 'true';

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    // navigate('/login'); // or wherever your login route is
    navigate('/');
  };

  return (
    <>
      {/* Top Header */}
      <Header
       toggleMenu={toggleMenu}
        isMenuOpen={isMenuOpen}
        handleLogout={handleLogout}
        showLinks={true}
       isSubscribed={isSubscribed} 
        
      />
      {/* <div className="headerTop">
        <img src="/assets/Flowlogic-Logo.svg" alt="FlowLogic Icon" />

        <div className="headerRightOuter">
          <div className="headerRight">
            <div className="profilePic">
              <img src="/assets/Profile-pic.png" alt="Profile" />
            </div>

            <nav className="navbar">
              <div
                className={`hamburger ${isMenuOpen ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                <div className="line line-1"></div>
                <div className="line line-2"></div>
                <div className="line line-3"></div>
              </div>

              <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                <ul>
                 <li><a href="/dashboard">Home</a></li>
                  <li><a href="/manage">Profile</a></li>
                  <li><a href="/change-password">Password</a></li>
                  <li><a href="#">Notifications</a></li>
                  <li><a href="#" onClick={handleLogout}>Logout</a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div> */}

      {/* Main Profile Section */}
      <div className="profile-page-container">
        {/* <div className="sidebar">
          <ul>
            <li className={activeTab === 'profile' ? 'active' : ''} onClick={() => setActiveTab('profile')}>Profile</li>
            <li className={activeTab === 'change-password' ? 'active' : ''} onClick={() => setActiveTab('change-password')}>Change Password</li>
          </ul>
        </div> */}
        <div className="content">
          {/* {activeTab === 'profile' ? <ProfileDetails /> : <ChangePassword />} */}
          {/* {activeTab === 'profile' ? <ProfileDetails /> : ''}  */}
          <ProfileDetails /> 
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
